const DAILY_STEP_CHALLENGE_NAME = 'physical_step_daily';

/** 오늘(로컬) 날짜 YYYY-MM-DD */
export function getLocalDateKey(date = new Date()) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

function isLastDateToday(lastDate) {
    if (!lastDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const lastDateObj = new Date(lastDate);
    lastDateObj.setHours(0, 0, 0, 0);

    return lastDateObj.getTime() === today.getTime();
}

/** 걷기 일간 챌린지(physical_step_daily) 오늘 보상 수령 여부 */
export function isDailyStepRewardReceivedToday(challengeProgresses) {
    if (!Array.isArray(challengeProgresses)) return false;

    const progress = challengeProgresses.find(
        p => p?.challenge?.type === 0 && p?.challenge?.name === DAILY_STEP_CHALLENGE_NAME
    );
    if (!progress || !isLastDateToday(progress.lastDate)) return false;

    const rewardPoints = progress.rewardPoints;
    return Array.isArray(rewardPoints) && rewardPoints.length > 0;
}
